import React, { Component } from 'react';
import './CreatorUploadMonetizationForm.css';

class CreatorMonetizationImpressionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {value: (props.params && props.params.impressionFee ? props.params.impressionFee : "")};

    this.handleChange = this.handleChange.bind(this);

  }

  handleChange(event) {
    if(this.props.checkString(event.target.value) || event.target.value === ""){
      this.setState({value: event.target.value});
      this.props.setImpressionFee(event.target.value);
    }
  }

  render() {
    return (
      <div>
        <label className="text-black">
          <input placeholder="Impression fee" className="placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900" type="text" value={this.state.value} onChange={this.handleChange} />
        </label>
        {
          this.state.value !== "" && !isNaN(this.props.usdPrice)
            ?
          "$ " + (this.state.value * this.props.usdPrice).toFixed(2)
            :
          null
        }
        {
          this.state.value !== "" && !isNaN(this.props.usdPrice)
            ?
          <br />
            :
          null
        }
        How much you will make in MATIC on every view of your video.
        Ex. if 1 million people view your video and you charge an impression fee of 1 cent, you will make $10,000
        You can set the impression to be $0 if you’d like for your viewers to see the content for free
      </div>
    );
  }
}

export default CreatorMonetizationImpressionForm;
